import { useEffect, useState } from 'react';

// Compact title bar for mobile, in the spirit of the Blitz page header: it
// stands in for the page title for as long as the real one is scrolled up
// behind the nav, and steps aside once it is back on screen. Tapping it
// returns to the top.
//
// `titleRef` points at the heading being tracked — measuring it beats a magic
// scroll offset, which drifts whenever the page header layout changes.

// Height of the sticky AdminNavigation the bar covers while it is shown.
const NAV_HEIGHT = 64;

function MobileTitleBar({ title, titleRef }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const rect = titleRef?.current?.getBoundingClientRect();
      setVisible(!!rect && rect.bottom <= NAV_HEIGHT);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [titleRef]);

  if (!title || !visible) return null;

  const handleClick = () => {
    setVisible(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid="mobile-title-bar"
      aria-label={`${title} — back to top`}
      className="md:hidden fixed inset-x-0 top-0 z-50 flex w-full items-center justify-between gap-3 border-b border-gray-200/50 dark:border-gray-800/50 bg-background-light/95 dark:bg-background-dark/95 px-4 py-4 backdrop-blur-sm"
    >
      <span className="truncate text-sm font-semibold text-gray-900 dark:text-white">
        {title}
      </span>
      <svg className="w-5 h-5 shrink-0 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
      </svg>
    </button>
  );
}

export default MobileTitleBar;
